import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

export const NavigationContext = createContext<ValueType>({})

type NavigationProviderProps = {
  value: object
  children: JSX.Element | JSX.Element[]
}

export type NavigationType = Record<string, any>

export type ValueType = {
  navigation?: NavigationType
  update?: (id: string, value: any) => void
}

export default function NavigationProvider({
  value,
  children,
}: NavigationProviderProps) {
  const [navigation, setNavigation] = useState({})

  const update = useCallback(
    (id, val) => {
      setNavigation((navigation) => ({ ...navigation, [id]: val }))
    },
    [setNavigation],
  )

  const processedValue: ValueType = useMemo(
    () => ({
      navigation: { ...value, ...navigation },
      update,
    }),
    [navigation, value, update],
  )

  return (
    <NavigationContext.Provider value={processedValue}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  return useContext(NavigationContext)
}
